import { forwardRef, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TooltipComponent } from "./tooltip.component";
import { AppMatModule } from "../../app-mat.module";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { NgxMatPopoverComponent } from "./ngx-mat-popover/ngx-mat-popover.component";

@NgModule({
  imports: [CommonModule, AppMatModule],
  declarations: [
    TooltipComponent,
    NgxMatPopoverComponent,
  ],
  exports: [TooltipComponent, NgxMatPopoverComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TooltipComponent),
      multi: true,
    },
  ],
})
export class TooltipModule {}
